/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_ProfileInputs */

const th_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์`)
};

const en_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const ja_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const zh_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资料`)
};

const es_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const pt_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const id_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const fr_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const tl_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const vi_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ`)
};

const ko_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필`)
};

const de_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const ru_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль`)
};

const tr_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

const pl_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const uk_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль`)
};

const hi_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल`)
};

const ar_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملف`)
};

const ms_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const bn_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোফাইল`)
};

const zh_tw2_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資料`)
};

const zh_hk2_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資料`)
};

const ur_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پروفائل`)
};

const fa_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمایه`)
};

const sw_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasifu`)
};

const nl_org_profile = /** @type {(inputs: Org_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Org_ProfileInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_profile = /** @type {((inputs?: Org_ProfileInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_ProfileInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_profile(inputs)
	if (locale === "ja") return ja_org_profile(inputs)
	if (locale === "zh") return zh_org_profile(inputs)
	if (locale === "es") return es_org_profile(inputs)
	if (locale === "pt") return pt_org_profile(inputs)
	if (locale === "id") return id_org_profile(inputs)
	if (locale === "fr") return fr_org_profile(inputs)
	if (locale === "tl") return tl_org_profile(inputs)
	if (locale === "vi") return vi_org_profile(inputs)
	if (locale === "ko") return ko_org_profile(inputs)
	if (locale === "de") return de_org_profile(inputs)
	if (locale === "ru") return ru_org_profile(inputs)
	if (locale === "tr") return tr_org_profile(inputs)
	if (locale === "it") return it_org_profile(inputs)
	if (locale === "pl") return pl_org_profile(inputs)
	if (locale === "uk") return uk_org_profile(inputs)
	if (locale === "hi") return hi_org_profile(inputs)
	if (locale === "ar") return ar_org_profile(inputs)
	if (locale === "ms") return ms_org_profile(inputs)
	if (locale === "bn") return bn_org_profile(inputs)
	if (locale === "zh-TW") return zh_tw2_org_profile(inputs)
	if (locale === "zh-HK") return zh_hk2_org_profile(inputs)
	if (locale === "ur") return ur_org_profile(inputs)
	if (locale === "fa") return fa_org_profile(inputs)
	if (locale === "sw") return sw_org_profile(inputs)
	if (locale === "nl") return nl_org_profile(inputs)
	return en_org_profile(inputs)
});